import { cloneElement, type CSSProperties, type FC, isValidElement, type ReactNode } from 'react';
import { Box, Flex, type FlexProps, type MantineFontSize, type StyleProp, Text } from '@mantine/core';
import { CopyValueButton } from './components';
import styles from './KeyValuePair.module.css';

type KeyValuePairProps = {
    label: string;
    value: ReactNode;
    copyValue?: string;
    size?: MantineFontSize;
    direction?: StyleProp<CSSProperties['flexDirection']>;
    w?: FlexProps['w'];
};

const renderValue = (value: ReactNode, size: MantineFontSize) => {
    if (isValidElement<{ style?: CSSProperties }>(value)) {
        return cloneElement(value, {
            style: {
                fontSize: 'inherit',
                lineHeight: 'inherit',
                // ...value.props.style,
            },
        });
    }

    return <Box size={size}>{value}</Box>;
};

export const KeyValuePair: FC<KeyValuePairProps> = ({
    label,
    value,
    copyValue,
    size = 'sm',
    direction = 'column',
    w,
}) => {
    return (
        <Flex
            className={styles.root}
            gap={0}
            fz={size}
            direction={direction}
            w={w}
        >
            <Text
                size={size}
                c='dimmed'
            >
                {label}
            </Text>

            {copyValue !== undefined ? (
                <Box className={styles.copyableValueRow}>
                    <Box className={styles.copyableValue}>{renderValue(value, size)}</Box>

                    <CopyValueButton
                        label={label}
                        value={copyValue}
                    />
                </Box>
            ) : (
                renderValue(value, size)
            )}
        </Flex>
    );
};
